/**
 * Returns a function to standardise the handling of different errors during fetch calls.
 * @param functionName - The name of the function that called the error catcher. Only used for pretty console logs.
 * @param subclass - The error class that should be caught. Other errors should be rethrown.
 * @param defaultValue - The default value that should be used instead of the expected value. Defaults to null
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function catchError<T extends Error>(
  functionName: string,
  subclass: Function,
  defaultValue: any | null = null
) {
  return (reason: T) => {
    if (reason instanceof subclass) {
      console.warn(
        `[${functionName}] ${reason.name}: ${reason.message}. Using default values instead.`
      )
      return defaultValue
    }

    throw reason
  }
}
